import { render } from "./NavigationButton.vue?vue&type=template&id=71e60df9&ts=true"
import script from "./NavigationButton.vue?vue&type=script&lang=ts"
export * from "./NavigationButton.vue?vue&type=script&lang=ts"

import exportComponent from "/home/schulz/philipp-schulz.dev/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__